<template>
  <form action="/api/quotation" id="form_car" method="POST" ref="formCar" @submit="handleSubmit">
    <input type="hidden" name="quotation_id" :value="quotationId" />
    <input type="hidden" name="quotation_type" :value="currentQuotationType" />

    <car-recap :infocar="infocar" :quotationType="quotationType"></car-recap>

    <form-fields
      :type="quotationType"
      :km.syncValue="km"
      :km_placeholder="km_placeholder"
      :notes="notes"
      :kmMensili="kmMensili"
      :cap="cap"
      :anni="anni"
      :mesi="mesi"
      @date-validation="updateDateValidation"
    ></form-fields>

    <buy-quotation-btn
      :type="quotationType"
      :loading="loading"
      @submit-form="onSubmitForm"
      @updateLoading="updateLoading"
      :liveMarketExists="liveMarketExists"
      :promotions="promotions"
      :is-date-valid="isDateValid"
    ></buy-quotation-btn>
  </form>
</template>

<script>
import CarRecap from './CarRecap.vue';
import FormFields from './FormFields.vue';
import BuyQuotationBtn from './BuyQuotationBtn.vue';

export default {
  name: 'BuyQuotationForm',
  components: {
    CarRecap,
    FormFields,
    BuyQuotationBtn,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    quotationType: {
      type: String,
      required: true,
    },
    liveMarketExists: {
      type: Boolean,
      required: true,
    },
    promotions: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      kmValue: this.data.km,
      currentQuotationType: this.quotationType,
      isDateValid: false,
    };
  },
  computed: {
    infocar() {
      return this.data.infocar;
    },
    km() {
      return this.data.km;
    },
    km_placeholder() {
      return this.data.km_placeholder || '';
    },
    notes() {
      return this.data.notes;
    },
    quotationId() {
      return this.data.quotation_id;
    },
    anni() {
      return this.data.anni;
    },
    mesi() {
      return this.data.mesi;
    },
    kmMensili() {
      return this.data.kmMensili;
    },
    cap() {
      return this.data.cap;
    },
  },
  methods: {
    updateDateValidation(isValid) {
      this.isDateValid = isValid;
    },
    updateLoading(isLoading) {
      this.loading = isLoading;
    },
    onSubmitForm(newType) {
      this.currentQuotationType = newType;
      this.$nextTick(() => {
        this.$refs.formCar.submit();
      });
    },
    handleSubmit(event) {
      this.loading = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BuyQuotationForm.vue